// extracted by mini-css-extract-plugin
module.exports = {"root":"_2JtC8pL","root_hasCount":"_2uL2Ss_","truncate":"_2jjdQHt","count":"_2bL2kld"};
    if(module.hot) {
      // 1545369460198
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  